module.exports = __webpack_public_path__ + "img/logo-180x180.f2c06aac.png";